import { render } from "./ForgotPasswordForm.vue?vue&type=template&id=7b2bce4c"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__